import React, { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import axios from "axios";
import { format } from "date-fns";


const HistoryDisplay = ({ selectedLead, activityEntry, rows2 }) => {

  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse( localStorage.getItem("apiPaths") ) : "-"

  const [rows, setRows] = useState([]);

  const [fullHistoryOfStatusChange, setFullHistoryOfStatusChange] = useState(null)

  useEffect(() => {
    if (selectedLead) {

      callApiToGetFullHistoryOfStatusChange()

    }
  }, [selectedLead]);

  useEffect(() => {
    if (activityEntry) {
      // Append activityEntry dynamically when it's set
      setRows((prevRows) => {
        const updatedRows = [...prevRows, activityEntry].sort(
          (a, b) => new Date(a.date) - new Date(b.date)
        );

        // Update local storage with the new timeline
        localStorage.setItem("leadsHistory", JSON.stringify(updatedRows));
        return updatedRows;
      });
    }
  }, [activityEntry]);

  const callApiToGetFullHistoryOfStatusChange = () => {

    console.log("selectedLead History ", selectedLead)

    let compcode = company_code_from_local_storage
    let mode = "LEADTIMELINE"
    let task_owner_id = selectedLead.deptno
    let task_id = selectedLead.lead_id


    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMTaskHistoryList/${compcode}/${mode}/${task_owner_id}/${task_id}`;
    axios.get(apiUrl).then((res) => {

      setFullHistoryOfStatusChange(res.data)

    }).catch((err) => {

    })

  }

  return (
    <div>
      <h3 className="text-xl font-semibold my-4">Lead Timeline</h3>


      <div>
        {
          fullHistoryOfStatusChange ?
            fullHistoryOfStatusChange?.map((item) => {
              return (
                <div>
                  <p>{ format(item.create_date, "yyyy-MM-dd") }</p>
                  <p>{item.status}</p>
                </div>
              )
            })
            :
            <p>No Data available</p>
        }
      </div>





    </div>
  );
};

export default HistoryDisplay;
